import { DocCategory } from "../../gatsby-node-transformer-asciidoc.types";
import { isGuide } from "../types/types";

export function getDocCategory(slug: string): DocCategory {
  let slugParts = slug.split("/").filter((part) => part);
  // If it's an actual path rather than just a slug.
  if (slugParts[0] === "en") {
    slugParts = slugParts.slice(1);
  }
  // Skip the version and grab next component of slug.
  const category = slugParts[1];
  if (category === "release_notes" || isGuide(category)) return category;
  // @ts-ignore TS2322
  return null;
}
